import './Loading.css'


export const LoadingView = () => {
    return (
        <>
        <div className="loading-wrapper flex align-center justify-center">
            <div className="lds"><div></div><div></div><div></div></div>
        </div>
        </>
    )
}

export const SearchLoadingView = () => {
    return (
        <div className="loader" style={{position:'absolute', right: "5px"}}></div>
    )
}

export const LoadingTableCell = ():JSX.Element => {
    return (
        <div className='bg-gray red' style={{width: '100%', height: '100%', display:"block", content:""}} />
    )
}